<template>
  <el-form ref="form" label-position="top">
    <h1>About Abilities</h1>

    <p>
      Each of us has abilities that we have discovered and learned over our lifetime. Read through this list
      of specialized abilities and check the abilities that you excel at and love doing.
    </p>

    <div v-for="group in groups" :key="group.name" class="ability-group">
      <h2>{{ group.name }}</h2>
      <el-form-item>
        <el-checkbox-group
            class="abilities"
            :value="getAbilitiesByGroup(group.name)"
            @input="storeAbilitiesByGroup(group.name, arguments[0])">
          <el-checkbox v-for="option in group.options" :key="option" :label="option" />
        </el-checkbox-group>
      </el-form-item>
    </div>

    <ui-form-actions>
      <el-button @click="goBack">Back</el-button>
      <el-button type="primary" @click="goForward">Continue</el-button>
    </ui-form-actions>
  </el-form>
</template>

<script>
  /* eslint-disable max-len */

  import get from 'lodash/get';
  import step from '../mixins/step';

  export default {
    mixins: [step],
    name: 'Abilities',
    methods: {
      goBack() {
        this.$router.back();
      },
      goForward() {
        this.$router.push({ path: '/personality' });
      },
      getAbilitiesByGroup(groupName) {
        return get(this.abilities, groupName, []);
      },
      storeAbilitiesByGroup(groupName, abilities) {
        this.$store.commit('setAbilitiesByGroup', { group: groupName, abilities });
      },
    },
    computed: {
      abilities() {
        return this.$store.state.abilities;
      },
    },

    data() {
      return {
        groups: [
          {
            name: 'Professional',
            options: [
              'Advertising',
              'Career Counseling',
              'Carpet Cleaning',
              'Chiropractic',
              'Computer Programming',
              'Counseling',
              'Day Care Director',
              'Dental',
              'Engineer',
              'Financial',
              'Journalist/Writer',
              'Landscaping',
              'Law Enforcement',
              'Legal',
              'Medical',
              'Mental Health',
              'Paramedic/EMT',
              'Personnel Manager',
              'Public Relations',
              'Radio',
              'Social Work',
              'Systems analyst',
              'Television',
              'Window Washing',
            ],
          },
          {
            name: 'Music',
            options: [
              'Arranger',
              'Bassist',
              'Chart Songs',
              'Choir',
              'Choir Director',
              'Composer',
              'Drummer',
              'Guitar player',
              'Keyboard player',
              'Other Instruments',
              'Vocalist',
            ],
          },
          {
            name: 'Art',
            options: [
              'Artist',
              'Crafts',
              'Decorating',
              'Graphic Design',
              'Multimedia',
              'Photography',
            ],
          },
          {
            name: 'Leader',
            options: [
              'Couples',
              'Elementary',
              'Junior High',
              'Men\'s Group',
              'Preschool',
              'Senior High',
              'Singles',
              'Tutoring',
              'Women\'s Group',
            ],
          },
          {
            name: 'Machinist',
            options: [
              'Auto Mechanic',
              'Computer Repair',
              'Copier Repair',
              'Diesel Mechanic',
              'Mechanics',
              'Small Engine',
            ],
          },
          {
            name: 'Missions',
            options: [
              'Evangelism',
              'Missionary',
            ],
          },
          {
            name: 'Drama',
            options: [
              'Acting',
              'Dance',
              'Mime/Clown',
              'Poet',
              'Writer',
            ],
          },
          {
            name: 'Production',
            options: [
              'Lighting',
              'Producer',
              'Set Design',
              'Sound',
              'Stage Hand',
              'Studio Recording',
              'Video',
            ],
          },
          {
            name: 'Construction',
            options: [
              'Architect',
              'Cabinets',
              'Carpenter',
              'Carpet',
              'Concrete',
              'Drafting',
              'Drywall',
              'Electrical',
              'Finishing',
              'General Contractor',
              'Heating/AC',
              'Interior Design',
              'Masonry',
              'Painting',
              'Papering',
              'Plumbing',
              'Roofing',
              'Telephones',
              'Tile',
            ],
          },
          {
            name: 'Office',
            options: [
              'Data Entry',
              'Mac Products',
              'MS Office Products',
              'Office Manager',
              'Receptionist',
            ],
          },
          {
            name: 'General',
            options: [
              'Bookstore',
              'Cashier',
              'Child Care',
              'Customer Service',
              'Food Service',
              'Tax Deductions',
              'Transportation',
              'Weddings',
            ],
          },
          {
            name: 'Maintenance',
            options: [
              'Building',
              'Cleaning',
              'Gardening',
              'Grounds',
            ],
          },
          {
            name: 'Sports',
            options: [
              'Basketball',
              'Football',
              'General Athlete',
              'Golf',
              'Lifeguard',
              'Soccer',
              'Softball',
              'Tennis',
            ],
          },
          {
            name: 'Work With',
            options: [
              'Alzheimer\'s',
              'Hospital Visits',
              'Learning/Teaching',
              'Making Homemade Meals',
              'Nursing Homes',
              'Shut-Ins',
            ],
          },
        ],
      };
    },
  };
</script>

<style lang="scss">
  @import "~styles/vars";
  @import "~element-theme/mixins/mixins.scss";

  .abilities {
    display: flex;
    flex-wrap: wrap;

    .el-checkbox {
      flex-basis: 100%;
      display: block;
      margin: 0 0 .75rem !important;

      @include res(lg) {
        flex-basis: 33.33%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Abilities.vue